import React from 'react';
import {ReactComponent as StarsIcon} from '../../../assets/icons/Stars.svg';
import {ReactComponent as StarsEmptyIcon} from '../../../assets/icons/StarsEmpty.svg';
import {ReactComponent as StarsHalfIcon} from '../../../assets/icons/StarsHalf.svg';

const Rating = ({mark}) => {
  const renderStars = (mark) => {
    const fullStars = Math.floor(mark);
    const hasHalfStar = mark % 1 !== 0;
    const emptyStars = 5 - fullStars - (hasHalfStar ? 1 : 0);

    const stars = [];

    for (let i = 0; i < fullStars; i++) {
      stars.push(<StarsIcon key={`full-${i}`} />);
    }

    if (hasHalfStar) {
      stars.push(<StarsHalfIcon key='half' />);
    }

    for (let i = 0; i < emptyStars; i++) {
      stars.push(<StarsEmptyIcon key={`empty-${i}`} />);
    }

    return stars;
  };

  return <div className='rating'>{renderStars(mark)}</div>;
};

export default Rating;
